import { useQuery } from '@tanstack/react-query';
import { queryFn } from './queryFn';
import { useNarrativeSlug } from '@/pages/Narrative/hooks';

export const getQueryKey = (slug: string): [string, string] => [
  'NARRATIVE',
  slug,
];

export const useNarrative = () => {
  const slug = useNarrativeSlug();
  const { data, isLoading, error } = useQuery({
    enabled: Boolean(slug),
    queryFn,
    staleTime: 3600000,
    queryKey: getQueryKey(slug),
  });
  return { data, isLoading, error };
};
